module.exports = __webpack_public_path__ + "static/media/My Docs White.838cb771.png";